module.exports = __webpack_public_path__ + "static/media/macos-toolkit-still-open.bd905257.jpg";